"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingSkeleton = exports.ImageNotFoundWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/* eslint-disable import/prefer-default-export */

var ImageNotFoundWrapper = _styledComponents["default"].div.withConfig({
  displayName: "indexstyles__ImageNotFoundWrapper",
  componentId: "sc-1is7rta-0"
})(["position:relative;width:100%;height:100%;& > span{font-weight:700;font-size:", ";width:100%;text-align:center;color:#000000;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:100;}& > img{width:", ";opacity:0.25;}& > .center-backup-img{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);}"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? '16px' : '24px';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? '100%' : '450px';
});
exports.ImageNotFoundWrapper = ImageNotFoundWrapper;
var LoadingSkeleton = _styledComponents["default"].img.withConfig({
  displayName: "indexstyles__LoadingSkeleton",
  componentId: "sc-1is7rta-1"
})(["@keyframes flickerAnimation{0%{opacity:1;}50%{opacity:0.3;}100%{opacity:1;}}animation:flickerAnimation 3s infinite;"]);
exports.LoadingSkeleton = LoadingSkeleton;
//# sourceMappingURL=index.styles.js.map